export default "https://cdn-static.gokick.com/assets/4894ba43e4289cab16e653fbabc6637092de6282/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";